module.exports = __webpack_public_path__ + "static/media/fs_truman-light-webfont.13448b66.woff";